import { cn } from '@/lib/utils'

/**
 * Nolens Vacations mark: the family "N" of four connected nodes, with the top-right
 * node as a sun (accent colour, small rays) — same structure as every Nolens app,
 * only the accent and the highlighted node change.
 */
export function LogoMark({ className, title = 'Nolens Vacations' }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={cn('size-5', className)} role="img" aria-label={title} fill="none">
      <rect x="0.5" y="0.5" width="23" height="23" rx="6.5" className="fill-fg" />
      <path d="M7 17V7l10 10V7" className="stroke-bg" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="7" cy="7" r="1.6" className="fill-bg" />
      <circle cx="7" cy="17" r="1.6" className="fill-bg" />
      <circle cx="17" cy="17" r="1.6" className="fill-bg" />
      <g className="stroke-accent" strokeWidth="1" strokeLinecap="round">
        <path d="M17 2.6v1.1M21.4 7h-1.1M20.1 3.9l-.8.8M13.9 3.9l.8.8" />
      </g>
      <circle cx="17" cy="7" r="2" className="fill-accent stroke-fg" strokeWidth="0.8" />
    </svg>
  )
}

export function Logo({ className, compact }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark />
      {!compact && (
        <span className="flex items-baseline gap-1.5">
          <span className="text-[15px] font-semibold tracking-[0.14em]">NOLENS</span>
          <span className="text-[13px] font-medium text-accent">Vacations</span>
        </span>
      )}
    </span>
  )
}
